module.exports = __webpack_public_path__ + "static/aire-acondicionado-064daa794dcaecfd71102869373625a8.jpg";